module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.countDown.total > 0) ? _c('div', {
    staticClass: "new-count-down"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("countDown")))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.countDown.days) + " :")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.countDown.hours) + " :")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.countDown.minutes) + " :")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.countDown.seconds))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-217722ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/choosePackage/countDownNew.vue
// module id = 1276
// module chunks = 1